import SkeletonList from 'components/skeleton/skeleton-list/SkeletonList';
import React, { FC } from 'react';

interface ContactSkeletonProps {}

const ContactSkeleton: FC<ContactSkeletonProps> = () => {
  return <SkeletonList rows={2} />;
};

export default ContactSkeleton;
